module.exports = __webpack_public_path__ + "img/emoji_89.71283446.png";